export enum inventoryPaths {
  dashboard = '/dashboard',
  root = '/inventory',
  overview = '/inventory/overview',
  overviewReportPresets = '/inventory/reports/overview/presets',
  projectedRequirements = '/inventory/projected-requirements',
  projectedRequirementsReportPresets = '/inventory/reports/projected-requirements/presets',
  transactions = '/inventory/transactions',
  orderIngredients = '/inventory/order-ingredients',
  weighbridge = '/inventory/weighbridge',
}
